const colors = require('tailwindcss/colors');
const defaultTheme = require('tailwindcss/defaultTheme');

const themeColors = {
  ...colors,
  transparent: 'transparent',
  primary: 'black',
  secondary: 'black',
  black: '#000000',
  white: '#FFFFFF',
  reading: {
    light: '#9EA6B1',
    DEFAULT: '#63686F',
    dark: '#747C7B',
  },
  bluelight: {
    light: '#1949E7',
    DEFAULT: '#1949E7',
    dark: '#243557',
  },
  sun: {
    light: '#FEAE00',
    DEFAULT: '#FEAE00',
    dark: '#FEAE00',
  },
  kids: {
    light: '#FC6806',
    DEFAULT: '#FC6806',
    dark: '#FC6806',
  },
  original: {
    light: '#EF233C',
    DEFAULT: '#EF233C',
    dark: '#EF233C',
  },
  accessory: {
    light: '#000000',
    DEFAULT: '#000000',
    dark: '#000000',
  },
  gift: {
    light: '#000000',
    DEFAULT: '#000000',
    dark: '#000000',
  },
  dual: {
    light: '#DBFE16',
    DEFAULT: '#DBFE16',
    dark: '#272A25',
  },
  sport: {
    light: '#61B232',
    DEFAULT: '#61B232',
    dark: '#61B232',
  },
  new: '#2ECC71',
  redChristmas: '#CE3821',
  greenChristmas: '#0D4425',
  redQuiz: '#EA403F',
  lightBeigeSport: '#F4ECE0',
  darkBlueSport: '#467D95',
  darksport: '#525F43',
  jet: '#CB8753',
  ['light-gray']: '#D7D7D7',
  ['acetate-alt']: '#FDF185',
  ['acetate']: '#F5552B',
  ['acetate-bis']: '#E27928',
  zambezi: '#585858',
  ['sun-alt']: '#bb7613',
  refresh: '#1589DC',
  'refresh-light': '#009FE3',
  'refresh-dark': '#144D7F',
};

module.exports = {
  important: true,
  purge: {
    content: ['./src/**/*.{js,jsx,ts,tsx}'],
    options: {
      // Whitelisting some classes to avoid purge
      safelist: [
        /^bg-/,
        /^h-/,
        /^text-/,
        /^fill-/,
        /^font-/,
        /^border-/,
        /^ring-/,
        /^hover:ring-/,
        /^opacity-/,
        /^object-/,
        /^bg-gradient/,
        /^items-/,
        /^rounded-/,
        /^from-/,
      ],
    },
  },
  darkMode: false,
  plugins: [require('@tailwindcss/forms')],
  theme: {
    transitionProperty: {
      height: 'height',
      width: 'width',
    },
    borderColor: {
      ...themeColors,
      DEFAULT: colors.gray['700'],
    },
    fontFamily: {
      gilmer: ['Gilmer', 'Inter'],
      monument: ['Monument', 'Inter'],
      christmas: ['Suifak', 'Inter'],
    },
    colors: themeColors,
    fill: themeColors,
    scale: {
      ...defaultTheme.scale,
      25: '.25',
    },
    extend: {
      spacing: {
        88: '22rem',
        110: '28rem',
        128: '32rem',
        144: '36rem',
      },
      minWidth: () => ({
        '1/2': '50%',
        '1/4': '25%',
        '1/3': 'calc(100% / 3)',
        '2/3': 'calc(2 * (100% / 3))',
        '5/12': 'calc(5 * (100% / 12))',
        '4/14': 'calc(4 * (100% / 14))',
        '8/12': 'calc(8 * (100% / 12))',
        '10/12': 'calc(10 * (100% / 12))',
      }),
      minHeight: () => ({
        'screen-1/2': '50vh',
        'screen-2/3': 'calc(2 * (100vh / 3))',
      }),
      height: () => ({
        'screen/2': '50vh',
        'screen/3': 'calc(100vh / 3)',
        'screen-2/3': 'calc(2 * (100vh / 3))',
        'screen-3/4': 'calc(3 * (100vh / 4))',
      }),
      width: () => ({
        'screen/2': '50vw',
        'screen/3': 'calc(100vw / 3)',
        'screen-2/3': 'calc(2 * (100vw / 3))',
        'screen-95': '96vw',
      }),
    },
  },
  variants: {
    extend: {
      backgroundColor: ['checked'],
      borderColor: ['checked'],
      opacity: ['disabled'],
      translate: ['hover', 'last'],
      padding: ['hover'],
      fontWeight: ['hover'],
      ringColor: ['hover'],
      ringOffsetColor: ['hover'],
      ringOpacity: ['hover, active'],
      ringWidth: ['hover'],
    },
  },
};
